//settings
import React, { useState } from "react";

//styles
import StylesAbout from "./academic.module.scss";

//icons

import { FaLaptopCode } from "react-icons/fa";
import { RiTeamFill } from "react-icons/ri";
import { GrVmMaintenance } from "react-icons/gr";
import { GiLightBulb } from "react-icons/gi";
import { IoMdCloseCircleOutline } from "react-icons/io";

//assets
import cedula from "../../assets/about_me/cedula.png";
import diploma from "../../assets/about_me/diploma.jpeg";
import leyes from "../../assets/about_me/leyes.png";
import mencion from "../../assets/about_me/mencionH.jpeg";
import titulo from "../../assets/about_me/titulo.jpeg";

	
const AcademicView: React.FC = () => {

    const [showFile, setShowFile] = useState(0);

    const showVideo = () => {
        window.open("https://youtu.be/2A-foj6z3Og?list=LL&t=1222", "_blank");
    };

    return (
        <>
            <div className={[StylesAbout.__main_about_me_container].join(' ')}>
                <div className={[StylesAbout.__formation].join(' ')}>
                    <div className={[StylesAbout.__main_title].join(' ')}>
                            Formación
                    </div>
                    <div className={[StylesAbout.__work_type].join(' ')}>
                        <div className={[StylesAbout.__title_section].join(' ')}>
                            Experiencias de trabajo
                        </div>
                        <div className={[StylesAbout.__cards].join(' ')}>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><RiTeamFill /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Equipos de desarrollo</div>
                                <div className={[StylesAbout.__details].join(' ')}>He tenido experiencia trabajando en equipos completos de desarrollo, utilizando metodologías ágiles</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><GrVmMaintenance /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Mantenimientos</div>
                                <div className={[StylesAbout.__details].join(' ')}>He tenido experiencia ingresando a proyectos ya hechos, para darles continuidad y mejoras</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><GiLightBulb /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Creación de proyectos</div>
                                <div className={[StylesAbout.__details].join(' ')}>He tenido experiencia creando proyectos desde 0 hasta su despliegue a producción</div>
                            </div>
                            <div className={[StylesAbout.__card].join(' ')}>
                                <div className={[StylesAbout.__icon].join(' ')}><FaLaptopCode /></div>
                                <div className={[StylesAbout.__name].join(' ')}>Freelance</div>
                                <div className={[StylesAbout.__details].join(' ')}>He tenido experiencia como freelance creando sistemas a medida del cliente directo</div>
                            </div>
                        </div>
                    </div>

                    <div className={[StylesAbout.__academic].join(' ')}>
                        <div className={[StylesAbout.__title_section].join(' ')}>
                            Formación académica
                        </div>
                        <div className={[StylesAbout.__school].join(' ')}>
                            <div className={[StylesAbout.__name].join(' ')}>
                                TecNM Campus Puruándiro - Ingeniería en Tecnologías de la Información y Comunicaciones
                            </div>
                            <div className={[StylesAbout.__date].join(' ')}>
                                Ago 2016 - Jul 2021
                            </div>
                        </div>
                    </div>

                    <div className={[StylesAbout.__academic_goals].join(' ')}>
                        <div className={[StylesAbout.__title_section].join(' ')}>
                            Logros Académicos y de formación
                        </div>
                        <div className={[StylesAbout.__files_div].join(' ')}>
                            <div onClick={()=>setShowFile(1)} className={[StylesAbout.__button_file].join(' ')}>Cédula profesional</div>
                            <div onClick={()=>setShowFile(2)} className={[StylesAbout.__button_file].join(' ')}>Título</div>
                            <div onClick={()=>setShowFile(3)} className={[StylesAbout.__button_file].join(' ')}>Constancia de curso de derecho electoral</div>
                            <div onClick={()=>setShowFile(4)} className={[StylesAbout.__button_file].join(' ')}>Diploma "Tecnologías estratégicas"</div>
                            <div onClick={()=>setShowFile(5)} className={[StylesAbout.__button_file].join(' ')}>Mención honorífica por promedio</div>
                            <div onClick={()=>showVideo()} className={[StylesAbout.__button_file].join(' ')}>Video de participación en Game Changers 2020</div>
                        </div>
                    </div>
               </div>
            </div>
            {showFile > 0 &&
            <>
                <div className={[StylesAbout.__modal_show_file].join(' ')} onClick={() => setShowFile(0)}>
                    <div onClick={(e) => e.stopPropagation()} className={[StylesAbout.__modal].join(' ')}>
                        <div onClick={()=>setShowFile(0)} className={[StylesAbout.__close_button].join(' ')}><IoMdCloseCircleOutline /></div>
                        <div className={[StylesAbout.__file_show].join(' ')}>
                            {showFile === 1 && 
                                <img src={cedula} alt="cedula" />
                            }
                            {showFile === 2 && 
                                <img src={titulo} alt="titulo" />
                            }
                            {showFile === 3 && 
                                <img src={leyes} alt="constancia" />
                            }
                            {showFile === 4 && 
                                <img src={diploma} alt="diploma" />
                            }
                            {showFile === 5 && 
                                <img src={mencion} alt="mencion H." />
                            }
                        </div>
                    </div>
                </div>
            </>
            }
            
        </>
    );
}

export default AcademicView;